import {
  auditQueryEndPoint,
  fetchEvidenceDetailsEndPoint,
  fetchIncidentsEndPoint,
  fetchSingleIncidentDetailsEndPoint,
  filterEventsEndPoint,
  getActivityLogEndPoint,
} from "../configuration";
import axiosInstance from "../global/axiosInterceptor";
import { getCameraLocationForGivenID } from "./reportService";
import { ADMIN_ROLE } from "../global/constants/commonConstants";
import store from "../store";

export const Severity = {
  CRITICAL: "Critical",
  ELEVATED: "Elevated",
  LOW: "Low",
};

export const EventType = {
  SLIPANDFALL: "SLIPANDFALL",
  RESTRICTEDAREA: "RESTRICTEDAREA",
  DOOROPEN: "DOOROPEN",
  PEOPLECOUNTING: "PEOPLECOUNTING",
  VEHICLECOUNTING: "VEHICLECOUNTING",
  FIRE: "FIRE",
};

export const fetchIncidentActivity = async (activeSession) => {
  try {
    const accountId = activeSession.accountId;

    const response = await axiosInstance.post(auditQueryEndPoint(), {
      accountname: accountId,
      filter: {
        $selection: {
          resourcekind: "incidents",
          method: "patch",
        },
      },
    });
    const evidanceRes = response.data;
    return evidanceRes;
  } catch (e) {
    console.error("fetchIncidentActivity", e);
    return;
  }
};

export const fetchIncidentById = async (activeSession, incidentid) => {
  try {
    const accountId = activeSession.accountId;

    const response = await axiosInstance.post(filterEventsEndPoint(), {
      accountname: accountId,
      resourceidentifier: {
        incidentid,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};
//Commented because getIncidentsData() in Utils is taking care of this functionality
// export const fetchEvents = async (activeSession) => {
//   try {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: "Bearer " + activeSession.sessionToken,
//     };
//     const accountId = activeSession.accountId;

//     const response = await axiosInstance.post(fetchIncidentsEndPoint(), {
//         accountname: accountId,
//         filter: {
//           selection: {
//             eventtype: "",
//             starttime: "",
//             endtime: "",
//             status: "Unresolved",
//             siteid: "",
//             severity: "",
//           },
//           sort: [
//             {
//               order: "recent",
//             },
//           ],
//           limitnumber: 10,
//           page: "",
//           pagenumber: 1,
//         },
//     });
//     const res = response.data;
//     return res;
//   } catch (e) {
//     console.error("fetchEvents", e);
//     return;
//   }
// };

export const filterCriticalEvents = (data) => {
  return data?.filter((eventItem) => {
    return (
      eventItem.priority === Severity.CRITICAL &&
      eventItem.status === "Unresolved"
    );
  });
};

export const filterUnresolvedEvents = (data) => {
  return data?.filter((eventItem) => {
    return eventItem.status === "Unresolved";
  });
};

export const getCriticalUnresolvedEvents = async (
  activeSession,
  isCriticalUnresolved,
  sitesList=[],
  pageNumber = 1,
) => {
  if (!activeSession?.accountId) {
    return [];
  }

  const userRole = JSON.parse(sessionStorage.getItem("selectedRole"));
  const siteIds = [];
  sitesList && sitesList.length && sitesList.map((s) => siteIds.push(s.id));
  try {
    const result = await filterEvents(
      "",
      "",
      "",
      isCriticalUnresolved ? "Unresolved" : "",
      userRole !== ADMIN_ROLE ? siteIds : "",
      isCriticalUnresolved ? "Critical" : "",
      "recent",
      activeSession,
      pageNumber,
    );
    return result;
  } catch (e) {
    throw new Error(e);
  }
};

export const sortEventsInOrderOfOccurance = (data) => {
  return findOccurance(data, "applicationId");
};

const findOccurance = (arr, key) => {
  let arr2 = [];
  arr.forEach((x) => {
    // Checking if there is any object in arr2
    // which contains the key value
    if (
      arr2.some((val) => {
        return val[key] == x[key];
      })
    ) {
      // If yes! then increase the occurrence by 1
      arr2.forEach((k) => {
        if (k[key] === x[key]) {
          k["occurrence"]++;
        }
      });
    } else {
      // If not! Then create a new object initialize
      // it with the present iteration key's value and
      // set the occurrence to 1
      let a = {};
      a[key] = x[key];
      a["occurrence"] = 1;
      a["location"] = getCameraLocationForGivenID(x.evidences[0].sourceId);
      arr2.push(a);
    }
  });

  return arr2;
};

export function getCameraEventMap(eventData, cameraList) {
  const ceMap = {};

  if (eventData.length > 0) {
    for (let i = 0; i < cameraList?.length; i++) {
      // loop thru all events
      for (let j = 0; j < eventData?.length; j++) {
        if (
          eventData[j].status === "Unresolved" &&
          eventData[j].evidences.length > 0
        ) {
          for (let k = 0; k < eventData[j].evidences.length; k++) {
            if (
              typeof eventData[j].evidences[k].sourceId !== undefined &&
              cameraList[i].refid === eventData[j].evidences[k].sourceId
            ) {
              // if the camera does not have any events, set the map
              if (!ceMap.hasOwnProperty(cameraList[i].refid)) {
                ceMap[cameraList[i].refid] = eventData[j].id;
              }
            }
          }
        }
      }
    }
  }

  return ceMap;
}

export const getActivityLog = async (action, incidentid, activeSession) => {
  try {
    const accountId = activeSession.accountId;
    const response = await axiosInstance.post(getActivityLogEndPoint(), {
      accountname: accountId,
      activity: {
        action: action,
        actionby: activeSession?.userName,
        description: "",
      },
      resourceidentifier: {
        incidentid: incidentid,
      },
    });
    const evidences = response.data;
    return evidences;
  } catch (error) {
    console.error(
      "Getting following error while trying to filter incidents",
      error
    );
    return;
  }
};

export const filterEvents = async (
  eventtype,
  starttime,
  endtime,
  status,
  siteid,
  severity,
  order,
  activeSession,
  selectedPage
) => {
  try {
  const userRole = JSON.parse(sessionStorage.getItem("selectedRole"));
//   const sitesList = store.useSelector((state) => state?.sitesReducer);
//   console.log("sitesList in getIncidentsData: ", sitesList);
// //  const siteIds = getSiteIds(sitesList?.sites);
    const response = await axiosInstance.post(fetchIncidentsEndPoint(), {
      accountname: activeSession.accountId,
      filter: {
        selection: {
          eventtype: eventtype ? eventtype : "",
          starttime: starttime ? starttime : "",
          endtime: endtime ? endtime : "",
          status: status ? status : "",
          siteid: siteid ? siteid : "",
          severity: severity ? severity : "",
        },
        sort: [
          {
            order: order ? order : "",
          },
        ],
        limitnumber: 10,
        page: "",
        pagenumber: selectedPage || 1,
      },
    });
    return { res: response.data.data, headers: response.data };
  } catch (error) {
    console.error(
      "Getting following error while trying to filter incidents",
      error
    );
    throw new Error(error);
  }
};

export const fetchSingleIncidentById = async (activeSession, incidentid) => {
    const accountId = activeSession.accountId;
    const response = await axiosInstance.post(
      fetchSingleIncidentDetailsEndPoint(),
      {
        accountname: accountId,
        resourceidentifier: {
          incidentid: incidentid,
        },
      }
    );
    return response.data;
}